<template>
  <div class="languageSelection">
    <flag :squared="false" :iso="selectedLanguage.flag"/>
    <v-select label="name" :options="languageOptions" :clearable="false" :searchable="false" :value="selectedLanguage" @input="onSelect">
      <template slot="option" slot-scope="option">
        <flag :squared="false" :iso="option.flag"/> <span>{{option.name.toUpperCase()}}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import Config from './../config';
import 'vue-select/src/scss/vue-select.scss'
import vSelect from 'vue-select'

export default {
  name: 'LanguageSelector',
  components: {
    vSelect
  },
  data () {
    return {
      locales: Config.locales,
      selectedLanguage: {},
      languageOptions: [
        {
          name: 'English',
          flag: 'gb',
          code: 'en'
        },
        {
          name: '日本',
          flag: 'jp',
          code: 'ja'
        }
      ],
    }
  },
  methods: {
    onSelect: function(item) {
      this.selectedLanguage = item;
      this.$router.push({ path: this.$route.path, query: { lang: item.code } })
    }
  },
  mounted() {
    this.selectedLanguage = this.languageOptions[0];
    this.$router.onReady(() => {
      if(this.$route.query.lang) this.selectedLanguage = this.languageOptions.find(l => l.code == this.$route.query.lang)
    })
    
  }
}
</script>
<style lang="scss">
  @import '../styles/variables';
  .languageSelection {
    margin: 1em 0 0 0;
    float: right;
  }
  .vs__dropdown-toggle, .vs__dropdown-menu, .vs__dropdown-option, .vs__selected {
    border: none !important;
    text-transform: uppercase !important;
    color: #422bf2 !important;

    @media (max-width: $tabletSmall) {
      font-size: 1.125em;
    }

    @media(min-width: $tabletSmall) {
      font-size: 0.8333em;
    }

    @media(min-width: 1200px) {
      font-size: 1.125em;
    }
  }
  .vs__search {
    color: transparent;
  }
  .v-select {
    display: inline-block;
    width: 150px;
  }
  .flag-icon {
    @media(min-width: $tabletSmall) {
      top: 0px;
    }

    @media(min-width: 1200px) {
      top: -2px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LanguageSelector.vue